import axios from "axios";
import {
  HasPaymentMethodRequest,
  HasPaymentMethodResponse,
} from "../proto/api_pb";
import { RpcError } from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";

export const checkoutStripeSession = async (
  stripeCustomerId: string,
  accessToken: string,
  subcriptionPlan: string
): Promise<void> => {
  axios
    .post(`${process.env.REACT_APP_NFT_API_URL}stripe/checkout-session`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "customer-id": stripeCustomerId,
        "subscription-plan": subcriptionPlan,
      },
    })
    .then((res) => {
      console.log(res.data);
      window.location.href = res.data;
    })
    .catch((er) => {
      console.log(er);
    });
};

export const checkoutStripeCustomerPortal = async (
  stripeCustomerId: string,
  accessToken: string
): Promise<void> => {
  axios
    .post(
      `${process.env.REACT_APP_NFT_API_URL}stripe/customer-portal-session`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "customer-id": stripeCustomerId,
        },
      }
    )
    .then((res) => {
      console.log(res.data);
      window.location.href = res.data;
    })
    .catch((er) => {
      console.log(er);
    });
};

export const getHasPaymentMethod = async (
  token: string,
  id: string
): Promise<RpcError | HasPaymentMethodResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new HasPaymentMethodRequest();
    request.setUserId(id);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<HasPaymentMethodResponse | RpcError>((resolve, reject) => {
          ommuseClient.hasPaymentMethod(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
